/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface IUpdateEmailScope extends ng.IScope {
        vm: UpdateEmail;
    }

    interface IUpdateEmail {
    }

    class UpdateEmail implements IUpdateEmail {
        static controllerId: string = "updateEmail";
        static $inject: string[] = ["Restangular", "common", "$timeout"];
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        user: any;
        newEmail: string;
        saving: boolean;

        constructor(private Restangular: Restangular.IService,
            private common: ICommonFactory,
            private $timeout: angular.ITimeoutService) {
            this.log = common.logger.getLogFn(UpdateEmail.controllerId);
            this.logError = common.logger.getLogFn(UpdateEmail.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(UpdateEmail.controllerId, "success");
            this.activate();
        }

        activate() {
            var promises = [this.getProfile()];
            this.common.activateController(promises, UpdateEmail.controllerId)
                .then(() => {
                    this.log("Activated UpdateEmail View");
                    this.saving = false;
                    this.newEmail = '';
                });
        }

        getProfile = () => {
            return this.Restangular.one("users/profile").get()
                .then((result) => {
                    this.user = result;
                    this.user.permAddress = null;
                    this.user.mailAddress = null;
                }, (reason) => {
                    this.logError(reason, reason, true);
                });
        };

        save = () => {
            if (this.newEmail == '') {
                this.common.authentication.redirect();
            }
            else {
                this.saving = true;
                this.user.email = this.newEmail;
                this.Restangular.all("users/profile/save").customPUT(this.user)
                    .then((result) => {
                        this.common.authentication.redirect();
                    }, (reason) => {
                        this.saving = false;
                        this.logError(reason.data.message, reason, true);
                    })
            }
        }
    }

    angular.module("app").controller(UpdateEmail.controllerId, UpdateEmail);
}